(function () {
  'use strict';

  var API_URL = 'https://members.area27.com/api/public-form/submit';
  var TURNSTILE_SITEKEY = '0x4AAAAAAEmuJoQqpdpTHt6q';
  var TURNSTILE_ACTION = 'area27_form';
  var scriptPromise = null;

  function loadTurnstile() {
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      return Promise.resolve();
    }
    if (scriptPromise) return scriptPromise;
    scriptPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-a27-turnstile-loader]');
      var script = existing || document.createElement('script');
      function ready() {
        var attempts = 0;
        (function check() {
          if (window.turnstile && typeof window.turnstile.render === 'function') {
            resolve();
            return;
          }
          attempts += 1;
          if (attempts >= 100) {
            reject(new Error('Secure verification could not be loaded.'));
            return;
          }
          window.setTimeout(check, 100);
        }());
      }
      if (!existing) {
        script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        script.async = true;
        script.defer = true;
        script.setAttribute('data-a27-turnstile-loader', 'true');
        script.addEventListener('load', ready, { once: true });
        script.addEventListener('error', function () {
          reject(new Error('Secure verification could not be loaded.'));
        }, { once: true });
        document.head.appendChild(script);
      } else {
        ready();
      }
    });
    return scriptPromise;
  }

  function installStyles() {
    if (document.getElementById('A27DirectFormStyles')) return;
    var style = document.createElement('style');
    style.id = 'A27DirectFormStyles';
    style.textContent = [
      '.a27-direct-form-security{display:grid;gap:8px;margin:18px 0}',
      '.a27-direct-form-security p,.a27-direct-form-status{margin:0;font-size:.86rem;line-height:1.5}',
      '.a27-direct-form-status{width:100%;margin-top:10px}',
      '.a27-direct-form-status[data-state="error"]{color:#ffb5b5}',
      '.a27-direct-form-status[data-state="success"]{color:#9be6d2}',
      '[data-a27-direct-email-form] button[type="submit"][aria-busy="true"]{cursor:wait;opacity:.78}',
      '[data-a27-direct-email-form] button[type="submit"][aria-busy="true"]::after{content:"";display:inline-block;width:14px;height:14px;margin-left:10px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:a27-direct-form-spin .7s linear infinite}',
      '@keyframes a27-direct-form-spin{to{transform:rotate(360deg)}}'
    ].join('');
    document.head.appendChild(style);
  }

  function makeSubmissionId() {
    var time = Date.now().toString(36).toUpperCase();
    var bytes = new Uint8Array(6);
    window.crypto.getRandomValues(bytes);
    var random = Array.prototype.map.call(bytes, function (byte) {
      return (byte % 36).toString(36);
    }).join('').toUpperCase();
    return 'A27F-' + time + '-' + random;
  }

  function selectedValue(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      return field.checked ? (field.value || 'Yes') : '';
    }
    return String(field.value || '').trim();
  }

  function fieldLabel(field) {
    var name = String(field.name || 'Field');
    var bracket = name.match(/^contact\[([^\]]+)\]$/);
    return (bracket ? bracket[1] : name)
      .replace(/[_-]+/g, ' ')
      .replace(/\b\w/g, function (letter) { return letter.toUpperCase(); });
  }

  function buildFormBody(form) {
    var summarySelector = form.getAttribute('data-a27-summary-selector');
    var summary = summarySelector ? form.querySelector(summarySelector) : null;
    if (summary && String(summary.value || '').trim()) return String(summary.value).trim();

    var title = form.getAttribute('data-a27-form-title') || 'Area 27 Website Form';
    var groups = [];
    var groupIndex = {};
    Array.prototype.forEach.call(form.elements, function (field) {
      if (!field.name || field.disabled) return;
      if (/^(return_to|form_type|utf8|authenticity_token|cf[-_]turnstile[-_]response)$/i.test(field.name)) return;
      if (/website/i.test(field.name)) return;
      var value = selectedValue(field);
      if (!value) return;
      var label = fieldLabel(field);
      if (/signature image/i.test(label)) value = 'Digitally captured';
      if (value.length > 5000) value = value.slice(0, 5000) + '…';
      if (Object.prototype.hasOwnProperty.call(groupIndex, label)) {
        groups[groupIndex[label]].values.push(value);
      } else {
        groupIndex[label] = groups.length;
        groups.push({ label: label, values: [value] });
      }
    });
    return [title, ''].concat(groups.map(function (group) {
      return group.label + ': ' + group.values.join(', ');
    })).join('\n');
  }

  function valueForSelector(form, selector) {
    if (!selector) return '';
    var field = form.querySelector(selector);
    return field ? String(field.value || '').trim() : '';
  }

  function nameForSelectors(form, selectors) {
    if (!selectors) return '';
    return selectors.split(',').map(function (selector) {
      return valueForSelector(form, selector.trim());
    }).filter(Boolean).join(' ');
  }

  function setupForm(form) {
    if (form.dataset.a27DirectReady === 'true') return;
    form.dataset.a27DirectReady = 'true';

    var submitButton = form.querySelector('button[type="submit"], input[type="submit"]');
    if (!submitButton) return;
    var originalButtonText = submitButton.tagName === 'INPUT'
      ? submitButton.value
      : submitButton.textContent;
    var status = document.createElement('p');
    status.className = 'a27-direct-form-status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    submitButton.insertAdjacentElement('afterend', status);

    var security = document.createElement('div');
    security.className = 'a27-direct-form-security';
    var widget = document.createElement('div');
    var securityMessage = document.createElement('p');
    securityMessage.textContent = 'Complete the secure verification before sending.';
    security.appendChild(widget);
    security.appendChild(securityMessage);
    submitButton.parentNode.insertBefore(security, submitButton);

    var widgetId = null;
    var turnstileToken = '';
    loadTurnstile().then(function () {
      widgetId = window.turnstile.render(widget, {
        sitekey: TURNSTILE_SITEKEY,
        action: TURNSTILE_ACTION,
        theme: 'dark',
        callback: function (token) {
          turnstileToken = token || '';
          securityMessage.textContent = 'Secure verification complete.';
        },
        'expired-callback': function () {
          turnstileToken = '';
          securityMessage.textContent = 'Secure verification expired. Please complete it again.';
        },
        'error-callback': function () {
          turnstileToken = '';
          securityMessage.textContent = 'Secure verification needs to be completed again.';
        }
      });
    }).catch(function (error) {
      securityMessage.textContent = error.message;
      status.textContent = error.message;
      status.setAttribute('data-state', 'error');
    });

    form.addEventListener('submit', function (event) {
      if (event.defaultPrevented) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      status.textContent = '';
      status.removeAttribute('data-state');

      if (!turnstileToken && widgetId !== null && window.turnstile) {
        try { turnstileToken = window.turnstile.getResponse(widgetId) || ''; } catch (error) {}
      }
      if (!turnstileToken) {
        status.textContent = 'Complete the secure verification before sending.';
        status.setAttribute('data-state', 'error');
        security.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var emailSelector = form.getAttribute('data-a27-email-selector');
      var copySelector = form.getAttribute('data-a27-copy-selector');
      var copyEmailSelector = form.getAttribute('data-a27-copy-email-selector');
      var copyField = copySelector ? form.querySelector(copySelector) : null;
      var copyRequested = Boolean(copyField && copyField.checked);
      var submissionId = form.dataset.a27PendingSubmissionId || makeSubmissionId();
      form.dataset.a27PendingSubmissionId = submissionId;
      var payload = {
        submissionId: submissionId,
        formType: form.getAttribute('data-a27-form-type'),
        submitterName: nameForSelectors(form, form.getAttribute('data-a27-name-selectors')),
        customerEmail: valueForSelector(form, emailSelector),
        customerCopyEmail: copyRequested ? valueForSelector(form, copyEmailSelector) : '',
        copyRequested: copyRequested,
        formBody: buildFormBody(form),
        website: valueForSelector(form, form.getAttribute('data-a27-honeypot-selector')),
        turnstileToken: turnstileToken
      };

      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
      if (submitButton.tagName === 'INPUT') submitButton.value = 'Sending…';
      else submitButton.textContent = 'Sending…';
      status.textContent = 'Sending your form securely to Area 27…';

      fetch(API_URL, {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.error || 'The form could not be sent. Please try again.');
          return body;
        });
      }).then(function () {
        delete form.dataset.a27PendingSubmissionId;
        status.textContent = 'Thank you. Your form was sent successfully.';
        status.setAttribute('data-state', 'success');
        var returnTo = valueForSelector(form, 'input[name="return_to"]');
        if (returnTo && returnTo.charAt(0) === '/') {
          window.location.assign(returnTo);
          return;
        }
        form.reset();
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
        turnstileToken = '';
      }).catch(function (error) {
        status.textContent = error.message || 'The form could not be sent. Your entries are still here; please try again.';
        status.setAttribute('data-state', 'error');
        if (widgetId !== null && window.turnstile) window.turnstile.reset(widgetId);
        turnstileToken = '';
      }).finally(function () {
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-busy');
        if (submitButton.tagName === 'INPUT') submitButton.value = originalButtonText;
        else submitButton.textContent = originalButtonText;
      });
    });
  }

  function start() {
    installStyles();
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-a27-direct-email-form]'),
      setupForm
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
